import { GoogleOAuthProvider } from "@react-oauth/google";
import React from "react";
import { RouterProvider } from "react-router-dom";
import { TSAlertProvider } from "./common/components/general/TSAlertProvider";
import TSAuthProvider from "./common/components/general/TSAuthProvider";
import { TSDataProvider } from "./common/components/general/TSDataContext";
import { TSThemeProvider } from "./common/components/general/TSThemeProvider";
import router from "./common/router/router";
import config from "./config";


/// themes: light, background
const App = () => {
  return (
    <TSAlertProvider>
      <GoogleOAuthProvider clientId={config.googleClientId}>
        <TSAuthProvider>
          <TSThemeProvider defaultTheme="background">
            <TSDataProvider>
              <RouterProvider router={router} />
            </TSDataProvider>
          </TSThemeProvider>
        </TSAuthProvider>
      </GoogleOAuthProvider>
    </TSAlertProvider>
  );
};

export default App;
